import { render, staticRenderFns } from "./PreviousPageLink.vue?vue&type=template&id=32277973&scoped=true&"
import script from "./PreviousPageLink.vue?vue&type=script&lang=js&"
export * from "./PreviousPageLink.vue?vue&type=script&lang=js&"
import style0 from "./PreviousPageLink.vue?vue&type=style&index=0&id=32277973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32277973",
  null
  
)

export default component.exports